/**
 * Converts the given list to a CSV and downloads it.
 * @param list list to download
 * @param filename filename
 * @param additional additional data to add to the csv (optional)
 */
export function downloadListObjectAsCSV<T>(list: T[], additional: string = "", filename: string = "download.csv") {
    let csv = convertObjectlistToCSV(list);
    csv += additional;
    const blob = new Blob([csv], {type: "text/csv;charset=utf-8"});
    const element = document.createElement("a");
    element.href = URL.createObjectURL(blob);
    element.download = filename;
    document.body.appendChild(element);
    element.click();
}

/**
 * Converts the given list to a CSV
 * @param list
 * @returns
 */
function convertObjectlistToCSV(list: []) {
    let csv = "";
    const keys = Object.keys(list[0]);
    csv += keys.join(";") + "\n";
    list.forEach((item) => {
        const values = [];
        keys.forEach((key) => {
            values.push(item[key]);
        })
        csv += values.join(";") + "\n";
    })
    return csv
}

export function createDownloadObject(base64Data: string, filename: string) {
    // convert bytes from base64 to bytes
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {type: "application/octet-stream"});
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
}